import React from "react";
import MenuManager from "../../Components/Admin/MenuManager/MenuManager";

const Menu = () => {
  return <MenuManager />;
};

export default Menu;
